import { Box, Grid, GridItem, Text } from "@chakra-ui/react"
import React from "react"
import { Colors } from "../../theme/colors"

export const MS70RDocumentation: React.FC = (): JSX.Element => {
  const headerStyles = {
    fontWeight: "bold",
    bg: Colors.Primary.accent,
    px: "4px",
    py: "2",
    fontSize: "14px",
    color: "white",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const columnStyles = {
    px: "2",
    py: "2",
    bg: "white",
    fontSize: "14px",
    textAlign: "left" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row" as const,
    flexWrap: "wrap" as const
  }

  const frlStyle = {
    py: "2",
    bg: "white",
    fontSize: "14px",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const firstColumnStyles = {
    px: "4px",
    py: "2",
    bg: "white",
    fontSize: "14px",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const tableHeadingStyles = {
    mt: "6",
    fontWeight: "bold",
    fontSize: "18px",
    color: Colors.Primary.c1
  }

  return (
    <Box>
      <Text {...tableHeadingStyles}>Wall Systems – 40mm Collar Separation Flange to Flange</Text>
      <Text fontSize="16px" fontWeight="bold" color={Colors.Primary.c1} mb="4">
        Cable in Conduit in Plasterboard Lined Steel Stud Walls
      </Text>

      {/* Wall Systems Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="3fr 3fr repeat(4, 0.75fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Detail
          </GridItem>
          <GridItem {...headerStyles} colSpan={4}>
            FRL
          </GridItem>

          {/* FRL Sub-headers */}
          <GridItem {...headerStyles} colSpan={4}>
            Symmetrically Lined Stud Wall
          </GridItem>

          {/* FRL Sub-sub-headers */}
          <Box {...headerStyles}>≥1x13mm Sheets each side</Box>
          <Box {...headerStyles}>≥1x16mm Sheets each side</Box>
          <Box {...headerStyles}>≥2x13mm Sheets each side</Box>
          <Box {...headerStyles}>≥2x16mm Sheets each side</Box>

          {/* Row 1: Mix services */}
          <Box {...firstColumnStyles}>
            <b>Mix services</b>
          </Box>
          <Box {...columnStyles}>
            Various cable combinations from below <b> with or without</b> PVC conduit in the collar. Only one conduit allowed in the collar.
          </Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: One PVC Conduit */}
          <Box {...firstColumnStyles}>
            <b>
              One PVC Conduit <br />
              (DN 20-50mm)
            </b>
          </Box>
          <Box {...columnStyles}>1.6mm to 2.85mm wall thickness</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Row 3: Data and Comms Cables (Cat5e, Cat6, Cat7, RG6) - With conduit */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Data and Comms Cables </b>
              (Cat5e, Cat6, Cat7, RG6)
            </Text>
          </GridItem>
          <GridItem {...columnStyles}>
            1 to 100 cables <b>&nbsp;With or without</b> PVC conduit in the collar (Refer to line 2 for conduit details)
          </GridItem>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/120</Box>

          <GridItem {...columnStyles}>
            1 to 100 cables <b>&nbsp;Without</b> PVC conduit in the collar (Refer to line 2 for conduit details)
          </GridItem>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 5: Fibre optic cables (12F NBN) */}
          <Box {...firstColumnStyles}>
            <b>Fibre optic cables (12F NBN)</b>
          </Box>
          <Box {...columnStyles}>
            1 to full of cables <b>&nbsp;With or without</b> PVC conduit in the collar (Refer to line 2 for conduit details)
          </Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Row 5: Power Cables (max 16mm² 3C+E Cables) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Power Cables </b>
              <br />
              (max 16mm² 3C+E Cables)
            </Text>
          </GridItem>
          <GridItem {...columnStyles}>
            1 to full of cables <b>&nbsp;With</b> PVC conduit in the collar (Refer to line 2 for conduit details)
          </GridItem>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/120</Box>

          <GridItem {...columnStyles}>
            1 to full in collar <b>&nbsp;Without</b> PVC conduit in the collar (Refer to line 2 for conduit details)
          </GridItem>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} textAlign={"left" as const} colSpan={6}>
            For sealing around annular gap use{" "}
            <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px" }}>
              Snap Fire Seal FRAS
            </a>
            . See sealant details in{" "}
            <a target="_blank" href="/report/FCO3397">
              FCO3397
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8">
        Lagged Pipes in Plasterboard Lined Steel Stud Walls
      </Text>

      {/* Lagged Pipes Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="3fr 2fr 1fr repeat(4, 0.75fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Lagging Type
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Lagging Thickness
          </GridItem>
          <GridItem {...headerStyles} colSpan={4}>
            FRL
          </GridItem>

          {/* FRL Sub-headers */}
          <GridItem {...headerStyles} colSpan={4}>
            Symmetrically Lined Stud Wall
          </GridItem>

          {/* FRL Sub-sub-headers */}
          <Box {...headerStyles}>≥1x13mm Sheets each side</Box>
          <Box {...headerStyles}>≥1x16mm Sheets each side</Box>
          <Box {...headerStyles}>≥2x13mm Sheets each side</Box>
          <Box {...headerStyles}>≥2x16mm Sheets each side</Box>

          {/* Row 1: One set of Paircoil - PE Foam */}
          <GridItem {...firstColumnStyles} rowSpan={3}>
            <Text>
              <b>One set of Paircoil</b>
              <br />
              (Min. 1/4" & 3/8" Max. 3/8" & 3/4")
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>PE Foam</Box>
          <Box {...firstColumnStyles}>9-15mm</Box>
          <GridItem {...frlStyle} rowSpan={3}>
            -/60/60
          </GridItem>
          <GridItem {...frlStyle} rowSpan={3}>
            -/90/60
          </GridItem>
          <GridItem {...frlStyle} rowSpan={3}>
            -/120/120
          </GridItem>
          <GridItem {...frlStyle} rowSpan={3}>
            -/120/120
          </GridItem>

          {/* Row 2: One set of Paircoil - Thermotec E-Flex */}
          <Box {...firstColumnStyles}>Thermotec E-Flex</Box>
          <Box {...firstColumnStyles}>9-25mm</Box>

          {/* Row 3: One set of Paircoil - Foilflex or Sekisui Foam */}
          <Box {...firstColumnStyles}>Foilflex or Sekisui Foam (Foil faced)</Box>
          <Box {...firstColumnStyles}>25mm</Box>

          {/* Row 4: One lagged copper/steel pipe - PE Foam */}
          <GridItem {...firstColumnStyles} rowSpan={3}>
            <Text>
              <b>One lagged copper/steel pipe</b>
              <br />
              (1/4" to 3/4")
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>PE Foam</Box>
          <Box {...firstColumnStyles}>9-15mm</Box>
          <GridItem {...frlStyle} rowSpan={3}>
            -/60/60
          </GridItem>
          <GridItem {...frlStyle} rowSpan={3}>
            -/90/60
          </GridItem>
          <GridItem {...frlStyle} rowSpan={3}>
            -/120/120
          </GridItem>
          <GridItem {...frlStyle} rowSpan={3}>
            -/180/120
          </GridItem>

          {/* Row 5: One lagged copper/steel pipe - Thermotec E-Flex */}
          <Box {...firstColumnStyles}>Thermotec E-Flex</Box>
          <Box {...firstColumnStyles}>9-25mm</Box>

          {/* Row 6: One lagged copper/steel pipe - Foilflex or Sekisui Foam */}
          <Box {...firstColumnStyles}>Foilflex or Sekisui Foam (Foil faced)</Box>
          <Box {...firstColumnStyles}>25mm</Box>

          {/* Row 7: One 1" lagged copper/steel pipe - Thermotec E-Flex */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One 1" lagged copper/steel pipe</b>
              <br />
              (max 1.22mm wall thickness)
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>Thermotec E-Flex</Box>
          <Box {...firstColumnStyles}>9-25mm</Box>
          <GridItem {...frlStyle} rowSpan={2}>
            -/60/60
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/90/60
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/120/120
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/180/120
          </GridItem>

          {/* Row 8: One 1" lagged copper/steel pipe - Foilflex or Sekisui Foam */}
          <Box {...firstColumnStyles}>Foilflex or Sekisui Foam (Foil faced)</Box>
          <Box {...firstColumnStyles}>25mm</Box>

          {/* Row 9: One lagged PN12 PVC pipe - Armaflex FRV */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One lagged PN12 PVC pipe</b>
              <br />
              (max. 32mm)
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>Armaflex FRV</Box>
          <Box {...firstColumnStyles}>19-25mm</Box>
          <GridItem {...frlStyle} rowSpan={2}>
            -/60/60
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/90/60
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/120/120
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/180/120
          </GridItem>

          {/* Row 10: One lagged PN12 PVC pipe - Foilflex or Sekisui Foam */}
          <Box {...firstColumnStyles}>Foilflex or Sekisui Foam (Foil faced)</Box>
          <Box {...firstColumnStyles}>25mm</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7} textAlign={"left" as const}>
            For sealing around annular gap use{" "}
            <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px" }}>
              Snap Fire Seal FRAS
            </a>
            . See sealant details in{" "}
            <a target="_blank" href="/report/FCO3397">
              FCO3397
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8">
        Cable in Conduit in Rigid Walls
      </Text>

      {/* Cable in Conduit in Rigid Walls Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="3fr 3fr repeat(4, 0.75fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={2}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Detail
          </GridItem>
          <GridItem {...headerStyles} colSpan={4}>
            FRL
          </GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>75mm Hebel (single mesh)</Box>
          <Box {...headerStyles}>75mm Hebel (caged mesh)</Box>
          <Box {...headerStyles}>78mm Speedpanel w/ 13mm patch each side</Box>
          <Box {...headerStyles}>≥120mm Concrete or Masonary Wall</Box>

          {/* Row 1: Mix services */}
          <Box {...firstColumnStyles}>
            <b>Mix services</b>
          </Box>
          <Box {...columnStyles}>
            Various cable combinations from below with or without conduit in the collar. <br />
            Only one conduit allowed in the collar.
          </Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/90</Box>
          <Box {...frlStyle}>-/120/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: One PVC Conduit */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>One PVC Conduit</b>
              <br />
              (DN 20-50mm)
            </Text>
          </Box>
          <Box {...columnStyles}>1.6mm to 2.85mm wall thickness</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: Data and Comms Cables (Cat5e, Cat6, Cat7, RG6) - Detail 1 */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Data and Comms Cables</b>
              <br />
              (Cat5e, Cat6, Cat7, RG6)
            </Text>
          </GridItem>
          <GridItem {...columnStyles}>
            1 to 100 cables <b>&nbsp;With or without</b> PVC conduit in the collar (Refer to line 2 for conduit details)
          </GridItem>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: Data and Comms Cables (Cat5e, Cat6, Cat7, RG6) - Detail 2 */}
          <GridItem {...columnStyles}>
            1 to full Cables <b>&nbsp;With or without</b> PVC conduit in the collar (Refer to line 2 for conduit details)
          </GridItem>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: Fibre optic cables (12F NBN) */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>Fibre optic cables</b>
              <br />
              (12F NBN)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to full in collar or in conduit <b>&nbsp;With</b> PVC conduit in the collar (Refer to line 2 for conduit details)
          </Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: Power Cables (Max 16mm² 3C+E Cables) */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>Power Cables</b>
              <br />
              (Max 16mm² 3C+E Cables)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to full in collar <b>&nbsp;Without</b> PVC conduit in the collar (Refer to line 2 for conduit details)
          </Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/90</Box>
          <Box {...frlStyle}>-/120/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={6} textAlign={"left" as const}>
            For sealing around annular gap use{" "}
            <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px" }}>
              Snap Fire Seal FRAS
            </a>
            . See sealant details in{" "}
            <a target="_blank" href="/report/FCO3397">
              FCO3397
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8">
        Lagged Pipes in Rigid Walls
      </Text>

      {/* Lagged Pipes in Rigid Walls Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="3fr 2fr 1fr repeat(4, 0.75fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={2}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Lagging Type
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Lagging Thickness
          </GridItem>
          <GridItem {...headerStyles} colSpan={4}>
            FRL
          </GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>75mm Hebel (single mesh)</Box>
          <Box {...headerStyles}>75mm Hebel (caged mesh)</Box>
          <Box {...headerStyles}>78mm Speedpanel w/ 13mm patch each side</Box>
          <Box {...headerStyles}>≥120mm Concrete or Masonary Wall</Box>

          {/* Row 1: One set of Paircoil - PE Foam */}
          <GridItem {...firstColumnStyles} rowSpan={4}>
            <Text>
              <b>One set of Paircoil</b>
              <br />
              (Min. 1/4" & 3/8" Max. 3/8" & 3/4")
            </Text>
          </GridItem>
          <GridItem {...firstColumnStyles} rowSpan={2}>
            PE Foam
          </GridItem>
          <GridItem {...firstColumnStyles} rowSpan={2}>
            9-15mm
          </GridItem>
          <GridItem {...frlStyle} rowSpan={6}>
            -/90/90
          </GridItem>
          <GridItem {...frlStyle} rowSpan={6}>
            -/120/90
          </GridItem>
          <GridItem {...frlStyle} rowSpan={6}>
            -/120/90
          </GridItem>
          <GridItem {...frlStyle} rowSpan={6}>
            -/120/120
          </GridItem>

          {/* Row 2: One set of Paircoil - Thermotec E-Flex */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            Thermotec E-Flex
          </GridItem>
          <GridItem {...firstColumnStyles} rowSpan={2}>
            9-25mm
          </GridItem>

          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One lagged copper/steel pipe</b>
              <br />
              (1/4" to 3/4")
            </Text>
          </GridItem>
          {/* Row 3: One set of Paircoil - Foilflex or Sekisui Foam */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            Foilflex or Sekisui Foam (Foil faced)
          </GridItem>
          <GridItem {...firstColumnStyles} rowSpan={2}>
            25mm
          </GridItem>

          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One 1" lagged copper/steel pipe</b>
              <br />
              (max 1.22mm wall thickness)
            </Text>
          </GridItem>
          <GridItem {...firstColumnStyles}>Thermotec E-Flex</GridItem>
          <GridItem {...firstColumnStyles}>9-25mm</GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/90/90
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/120/90
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/120/90
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/120/120
          </GridItem>

          {/* Row 6: One lagged copper/steel pipe - Foilflex or Sekisui Foam */}
          <Box {...firstColumnStyles}>Foilflex or Sekisui Foam (Foil faced)</Box>
          <Box {...firstColumnStyles}>25mm</Box>

          {/* Row 9: One lagged PN12 PVC pipe - Armaflex FRV */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One laggeds PN12 PVC pipe</b>
              <br />
              (max. 32mm)
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>Armaflex FRV nitrile rubber</Box>
          <Box {...firstColumnStyles}>19-25mm</Box>
          <GridItem {...frlStyle} rowSpan={2}>
            -/90/90
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/120/90
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/120/90
          </GridItem>
          <GridItem {...frlStyle} rowSpan={2}>
            -/120/120
          </GridItem>

          {/* Row 10: One lagged PN12 PVC pipe - Foilflex or Sekisui Foam */}
          <Box {...firstColumnStyles}>Foilflex or Sekisui Foam (Foil faced)</Box>
          <Box {...firstColumnStyles}>25mm</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7} textAlign={"left" as const}>
            For sealing around annular gap use{" "}
            <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px" }}>
              Snap Fire Seal FRAS
            </a>
            . See sealant details in{" "}
            <a target="_blank" href="/report/FCO3397">
              FCO3397
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8">
        Cable in Conduit in MgO Walls
      </Text>

      {/* Cable in Conduit in MgO Walls Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="3fr 3fr 2fr" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Detail
          </GridItem>
          <GridItem {...headerStyles}>FRL</GridItem>
          <GridItem {...headerStyles}>Symmetrically Lined Stud Wall (min 90mm steel stud)</GridItem>
          <GridItem {...headerStyles}>≥1x10mm FireCrunch or ≥1x7.5mm Multiboard</GridItem>

          {/* Row 1: Mix services */}
          <Box {...firstColumnStyles}>
            <b>Mix services</b>
          </Box>
          <Box {...columnStyles}>
            Various cable combinations from below with or without conduit in the collar. Only one conduit allowed in the collar.
          </Box>
          <Box {...frlStyle}>-/90/60</Box>

          {/* Row 2: One PVC Conduit */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>One PVC Conduit</b>
              <br />
              (DN 20-50mm)
            </Text>
          </Box>
          <Box {...columnStyles}>1.6mm to 2.85mm wall thickness</Box>
          <Box {...frlStyle}>-/90/60</Box>

          {/* Row 3: Data and Comms Cables (Cat5e, Cat6, Cat7, RG6) - Detail 1 */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Data and Comms Cables</b>
              <br />
              (Cat5e, Cat6, Cat7, RG6)
            </Text>
          </GridItem>
          <GridItem {...columnStyles}>
            1 to 100 Cables <b>&nbsp;With or without</b> PVC conduit in the collar (Refer to line 2 for conduit details).
          </GridItem>
          <Box {...frlStyle}>-/90/60</Box>

          {/* Row 4: Data and Comms Cables (Cat5e, Cat6, Cat7, RG6) - Detail 2 */}
          <GridItem {...columnStyles}>
            1 to full Cables <b>&nbsp;With or without</b> PVC conduit in the collar (Refer to line 2 for conduit details).
          </GridItem>
          <Box {...frlStyle}>-/90/60</Box>

          {/* Row 5: Fibre optic cables (12F NBN) */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>Fibre optic cables</b>
              <br />
              (12F NBN)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to full in collar or in conduit <b>&nbsp;With</b> PVC conduit in the collar (Refer to line 2 for conduit details).
          </Box>
          <Box {...frlStyle}>-/90/60</Box>

          {/* Row 6: Power Cables (Up to 16mm² 3C+E Cables) */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>Power Cables</b>
              <br />
              (Up to 16mm² 3C+E Cables)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to full in collar <b>&nbsp;Without</b> PVC conduit in the collar (Refer to line 2 for conduit details).
          </Box>
          <Box {...frlStyle}>-/90/90</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={3} textAlign={"left" as const}>
            For sealing around annular gap use{" "}
            <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px" }}>
              Snap Fire Seal FRAS
            </a>
            . See sealant details in{" "}
            <a target="_blank" href="/report/FCO3397">
              FCO3397
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8">
        Lagged Pipes in MgO Walls
      </Text>

      {/* Lagged Pipes in MgO Walls Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="3fr 1fr 1fr 2fr" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Lagging Type
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Lagging Thickness
          </GridItem>
          <GridItem {...headerStyles}>FRL</GridItem>
          <GridItem {...headerStyles}>Symmetrically Lined Stud Wall (min 90mm stud)</GridItem>
          <GridItem {...headerStyles}>≥1x10mm FireCrunch or ≥1x7.5mm Multiboard</GridItem>

          {/* Row 1: One set of Paircoil - PE Foam */}
          <GridItem {...firstColumnStyles} rowSpan={3}>
            <Text>
              <b>One set of Paircoil</b>
              <br />
              (Min. 1/4" & 3/8" Max. 3/8" & 3/4")
            </Text>
          </GridItem>
          <GridItem {...firstColumnStyles} rowSpan={2}>
            PE Foam
          </GridItem>
          <GridItem {...firstColumnStyles} rowSpan={2}>
            9-15mm
          </GridItem>
          <GridItem {...frlStyle} rowSpan={6}>
            -/90/60
          </GridItem>

          {/* Row 2: One set of Paircoil - Thermotec E-Flex */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            Thermotec E-Flex
          </GridItem>
          <GridItem {...firstColumnStyles} rowSpan={2}>
            9-25mm
          </GridItem>

          {/* Row 3: One lagged copper/steel pipe - Foilflex or Sekisui Foam */}
          <GridItem {...firstColumnStyles} rowSpan={3}>
            <Text>
              <b>One lagged copper/steel pipe</b>
              <br />
              (1/4" to 3/4")
            </Text>
          </GridItem>
          <GridItem {...firstColumnStyles} rowSpan={2}>
            Foilflex or Sekisui Foam (Foil faced)
          </GridItem>
          <GridItem {...firstColumnStyles} rowSpan={2}>
            25mm
          </GridItem>

          {/* Row 5: One 1" lagged copper/steel pipe - Thermotec E-Flex */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One 1" lagged copper/steel pipe</b>
              <br />
              (max 1.22mm wall thickness)
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>Thermotec E-Flex</Box>
          <Box {...firstColumnStyles}>9-25mm</Box>
          <GridItem {...frlStyle} rowSpan={2}>
            -/90/60
          </GridItem>
          {/* Row 6: One 1" lagged copper/steel pipe - Foilflex or Sekisui Foam */}
          <Box {...firstColumnStyles}>Foilflex or Sekisui Foam (Foil faced)</Box>
          <Box {...firstColumnStyles}>25mm</Box>
          {/* Row 7: One lagged PN12 PVC pipe - Armaflex FRV */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One lagged PN12 PVC pipe</b>
              <br />
              (max. 32mm)
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>Armaflex FRV nitrile rubber</Box>
          <Box {...firstColumnStyles}>19-25mm</Box>
          <GridItem {...frlStyle} rowSpan={2}>
            -/90/60
          </GridItem>
          {/* Row 8: One lagged PN12 PVC pipe - Foilflex or Sekisui Foam */}
          <Box {...firstColumnStyles}>Foilflex or Sekisui Foam (Foil faced)</Box>
          <Box {...firstColumnStyles}>25mm</Box>
          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={4} textAlign={"left" as const}>
            For sealing around annular gap use{" "}
            <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px" }}>
              Snap Fire Seal FRAS
            </a>
            . See sealant details in{" "}
            <a target="_blank" href="/report/FCO3397">
              FCO3397
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8">
        Wall Systems – No Separation – Flange to Flange
      </Text>

      <Text fontSize="16px" mb="4" color={Colors.Primary.c1}>
        The FRLs in the tables above are modified by the FRLs in this table where the collars are mounted flange to flange.
      </Text>

      {/* Wall Systems – No Separation – Flange to Flange Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="2fr 1fr" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles}>Wall Types</GridItem>
          <GridItem {...headerStyles}>FRL</GridItem>

          {/* Row 1: ≥ 90mm Plasterboard wall */}
          <Box {...firstColumnStyles}>≥ 90mm Plasterboard wall (1 x 13mm + 64mm stud)</Box>
          <Box {...frlStyle}>-/60/60</Box>

          {/* Row 2: ≥ 96mm Plasterboard wall */}
          <Box {...firstColumnStyles}>≥ 96mm Plasterboard wall (1 x 16mm + 64mm stud)</Box>
          <Box {...frlStyle}>-/90/60</Box>

          {/* Row 3: ≥ 116mm Plasterboard wall */}
          <Box {...firstColumnStyles}>≥ 116mm Plasterboard wall (2 x 13mm + 64mm stud)</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: ≥ 128mm Plasterboard wall */}
          <Box {...firstColumnStyles}>≥ 128mm Plasterboard wall (2 x 16mm + 64mm stud)</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Row 5: 75mm Hebel PowerPanel (Single Mesh) */}
          <Box {...firstColumnStyles}>75mm Hebel PowerPanel (Single Mesh)</Box>
          <Box {...frlStyle}>-/90/90</Box>

          {/* Row 6: 75mm Hebel PowerPanel (Caged Mesh) */}
          <Box {...firstColumnStyles}>75mm Hebel PowerPanel (Caged Mesh)</Box>
          <Box {...frlStyle}>-/120/90</Box>

          {/* Row 7: 78mm Speedpanel with Plasterboard patch */}
          <Box {...firstColumnStyles}>78mm Speedpanel with Plasterboard patch</Box>
          <Box {...frlStyle}>-/120/90</Box>

          {/* Row 8: ≥ 120mm Concrete or Masonry Wall */}
          <Box {...firstColumnStyles}>≥ 120mm Concrete or Masonry Wall</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 9: ≥ 110mm FireCrunch wall */}
          <Box {...firstColumnStyles}>≥ 110mm FireCrunch wall (1x10mm + 90mm stud)</Box>
          <Box {...frlStyle}>-/90/60</Box>

          {/* Row 10: ≥ 105mm Multiboard wall */}
          <Box {...firstColumnStyles}>≥ 105mm Multiboard wall (1x7.5mm + 90mm stud)</Box>
          <Box {...frlStyle}>-/90/60</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={2} textAlign={"left" as const}>
            For sealing around annular gap use{" "}
            <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px" }}>
              Snap Fire Seal FRAS
            </a>
            . See sealant details in{" "}
            <a target="_blank" href="/report/FCO3397">
              FCO3397
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8">
        Concrete Slabs – 40mm collar separation
      </Text>

      <Text fontSize="16px" fontWeight="bold" color={Colors.Primary.c1} mb="4">
        Cable in Conduit in Concrete Slabs
      </Text>

      {/* Concrete Slabs – 40mm collar separation Cable in Conduit in Concrete Slabs Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="3fr 3fr repeat(2, 1fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Detail
          </GridItem>
          <GridItem {...headerStyles} colSpan={2}>
            FRL
          </GridItem>

          {/* FRL Sub-headers */}
          <GridItem {...headerStyles} colSpan={2}>
            Minimum slab thickness (X)
          </GridItem>

          {/* FRL Sub-sub-headers */}
          <Box {...headerStyles}>≥150mm</Box>
          <Box {...headerStyles}>≥175mm</Box>

          {/* Row 1: Mix services */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>Mix services</b>
            </Text>
          </Box>
          <Box {...columnStyles}>Various cable combinations from below. (Only one conduit allowed in the collar)</Box>
          <Box {...frlStyle}>-/180/60</Box>
          <Box {...frlStyle}>-/240/60</Box>

          {/* Row 2: One PVC Conduit */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>One PVC Conduit</b>
              <br />
              (DN 20-50mm)
            </Text>
          </Box>
          <Box {...columnStyles}>1.6mm to 3mm wall thickness. Minimum 100mm protruding above and below slab.</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 3: Data and Comms Cables (Cat5e) */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>Data and Comms Cables</b>
              <br />
              (Cat5e)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to 100 Cables <b>&nbsp;With or without</b> PVC conduit in the collar (Refer to line 2 for conduit details).
          </Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 4: Data and Comms Cables (Cat6, Cat7, RG6) */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>Data and Comms Cables</b>
              <br />
              (Cat6, Cat7, RG6)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to 60 Cables <b>&nbsp;With or without</b> PVC conduit in the collar (Refer to line 2 for conduit details).
          </Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 5: Fibre optic cables */}
          <Box {...firstColumnStyles}>
            <b>Fibre optic cables</b>
          </Box>
          <Box {...columnStyles}>
            20 x 11mm and 10 x 6mm diameter Garland Optical Fibre cable. <b>&nbsp;With or without</b> PVC conduit in the collar (Refer to line 2 for
            conduit details).
          </Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 6: Power Cables (6mm² 3C+E Cables & 16mm² 3C+E) - With conduit */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Power Cables</b>
              <br />
              (6mm² 3C+E Cables & 16mm² 3C+E)
            </Text>
          </GridItem>
          <GridItem {...columnStyles}>
            Up to 3 x 6mm² 3C+E and up to 3 x 16mm² 3C+E <b>&nbsp;With</b> PVC conduit in the collar. (Refer to line 2 for conduit details).
          </GridItem>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/180</Box>

          {/* Row 7: Power Cables (6mm² 3C+E Cables & 16mm² 3C+E) - Without conduit */}
          <GridItem {...columnStyles}>
            Up to 3 x 6mm² 3C+E and up to 6 x 16mm² 3C+E <b>&nbsp;Without</b> PVC conduit in the collar. (Refer to line 2 for conduit details).
          </GridItem>
          <Box {...frlStyle}>-/180/60</Box>
          <Box {...frlStyle}>-/240/60</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={4} textAlign={"left" as const}>
            For sealing around annular gap use{" "}
            <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px" }}>
              Snap Fire Seal FRAS
            </a>
            . See sealant details in{" "}
            <a target="_blank" href="/report/FCO3397">
              FCO3397
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8">
        Lagged Pipes in Concrete Slabs
      </Text>

      {/* Lagged Pipes in Concrete Slabs Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="3fr 1fr repeat(5, 0.75fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Slab Thickness
          </GridItem>
          <GridItem {...headerStyles} colSpan={5}>
            FRL for each lagging type
          </GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>K Flex ST</Box>
          <Box {...headerStyles}>Thermotec E-Flex</Box>
          <Box {...headerStyles}>SuperMax</Box>
          <Box {...headerStyles}>Armaflex FRV nitrile rubber</Box>
          <Box {...headerStyles}>Foilflex or Sekisui foam (Foil faced)</Box>

          {/* Lagging Thickness Sub-sub-headers */}
          <Box {...headerStyles}>9-25mm lagging</Box>
          <Box {...headerStyles}>9-25mm lagging</Box>
          <Box {...headerStyles}>9-25mm lagging</Box>
          <Box {...headerStyles}>9-25mm lagging</Box>
          <Box {...headerStyles}>25mm lagging</Box>

          {/* Row 1: One Paircoil (1/4" & 3/8" or 3/8" & 3/4") with services - ≥150mm */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One Paircoil (1/4" & 3/8" or 3/8" & 3/4")</b>
              <br />
              with the following services:
              <ul style={{ listStyleType: "disc", paddingLeft: "16px", textAlign: "left" }}>
                <li>One of up to 25mm PVC pipe</li>
                <li>One 2.5mm² 2C+E TPS power cable</li>
              </ul>
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>-/180/60</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/90</Box>
          <Box {...frlStyle}>-/180/90</Box>
          <Box {...frlStyle}>-/180/90</Box>

          {/* Row 2: One Paircoil (1/4" & 3/8" or 3/8" & 3/4") with services - ≥175mm */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>-/240/60</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/90</Box>
          <Box {...frlStyle}>-/240/90</Box>
          <Box {...frlStyle}>-/180/90</Box>

          {/* Row 3: One lagged copper/steel pipe (1/4" to 3/4") - ≥150mm */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One lagged copper/steel pipe</b>
              <br />
              (1/4" to 3/4")
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>-/180/60</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/90</Box>

          {/* Row 4: One lagged copper/steel pipe (1/4" to 3/4") - ≥175mm */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>-/240/60</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/180</Box>
          <Box {...frlStyle}>-/180/90</Box>

          <Box {...headerStyles}>
            <b>Service</b>
          </Box>
          <Box {...headerStyles}>
            <b>Slab Thickness</b>
          </Box>
          <Box {...headerStyles}>
            <b>9-25mm lagging</b>
          </Box>
          <Box {...headerStyles}>
            <b>9-25mm lagging</b>
          </Box>
          <Box {...headerStyles}>
            <b>9-25mm lagging</b>
          </Box>
          <Box {...headerStyles}>
            <b>9-25mm lagging</b>
          </Box>
          <Box {...headerStyles}>
            <b>25mm lagging</b>
          </Box>

          {/* Row 5: One 1" lagged copper/steel pipe (max 1.22mm wall thickness) - ≥150mm */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One 1" lagged copper/steel pipe</b>
              <br />
              (max 1.22mm wall thickness)
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>-/180/60</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/90</Box>
          <Box {...frlStyle}>-/180/90</Box>

          {/* Row 6: One 1" lagged copper/steel pipe (max 1.22mm wall thickness) - ≥175mm */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>-/240/60</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/90</Box>
          <Box {...frlStyle}>-/180/90</Box>

          {/* Row 7: One lagged PN12 PVC pipe (16 to 32mm) - ≥150mm */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One lagged PN12 PVC pipe</b>
              <br />
              (16 to 32mm)
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 8: One lagged PN12 PVC pipe (16 to 32mm) - ≥175mm */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7} textAlign={"left" as const}>
            For sealing around annular gap use{" "}
            <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px" }}>
              Snap Fire Seal FRAS
            </a>
            . See sealant details in{" "}
            <a target="_blank" href="/report/FCO3397">
              FCO3397
            </a>
          </GridItem>
        </Grid>
      </Box>
    </Box>
  )
}
